import Index from './index.vue'
// import Create from './components/Create.vue'
import List from './components/List.vue'
import Edit from './components/Edit.vue'
import Profile from './view/Profile.vue'

export default [
  {
    path: 'sadqaFinancialAid',
    name: 'sadqaFinancialAid',
    component: Index,
    title: 'sadqaFinancialAid',
    redirect: { name: 'sadqaFinancialAid-list' },
    children: [
      {
        path: 'list',
        name: 'sadqaFinancialAid-list',
        component: List,
      },
      {
        path: ':id/edit',
        name: 'edit-sadqaFinancialAid',
        component: Edit,
      },
      {
        path: ':id/profile',
        name: 'profile-sadqaFinancialAid',
        component: Profile,
      },
    ],
  },
]
